import { render, staticRenderFns } from "./archives_student.vue?vue&type=template&id=52a1985f&scoped=true&"
import script from "./archives_student.vue?vue&type=script&lang=js&"
export * from "./archives_student.vue?vue&type=script&lang=js&"
import style0 from "./archives_student.vue?vue&type=style&index=0&id=52a1985f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a1985f",
  null
  
)

export default component.exports